//landingPage
export const ABOUT_RESPONSE = "ABOUT_RESPONSE"
export const WHY_RESPONSE = "WHY_RESPONSE"
export const CONTACT_FORM_RESPONSE = "CONTACT_FORM_RESPONSE"
export const HOME_RESPONSE = "HOME_RESPONSE"
export const OWNERS_SAYING_RESPONSE = "OWNERS_SAYING_RESPONSE"
export const SEARCH_RESPONSE = "SEARCH_RESPONSE"
export const PRIVACY_TERMS_RESPONSE = "PRIVACY_TERMS_RESPONSE"